import { mtop } from '../../utils';
import { message } from 'antd';

export default {
  namespace: 'collections',
  state: {
    loanList: {
      projectList: [],
    },
    loanApply: false,
    confirmRes: {},
    codeStatus: false,
    interest: [],
    loanplaninfo: {},
    loanInvoiceInfo: {},
  },

  reducers: {
    setLoanList(state, { payload: loanList = {} }) {
      // 添加容错处理
      loanList.projectList = loanList.projectList ? loanList.projectList : [];
      // 每一个项目中的每一条账单添加利息，默认值是0
      loanList.projectList.forEach(({ billList = [] }) => {
        billList.forEach(item => {
          item.rateValue = item.rateValue ? item.rateValue : 0;
        });
      });
      return {
        ...state,
        loanList,
      };
    },
    setLoanApply(state, { payload: loanApply }) {
      return {
        ...state,
        loanApply,
      };
    },
    setLoanConfirm(state, { payload: confirmRes }) {
      return {
        ...state,
        confirmRes,
      };
    },
    setCodeStatus(state, { payload: codeStatus }) {
      return {
        ...state,
        codeStatus,
      };
    },
    setInterest1(state, { payload: resRate }) {
      // 需要设置对应项目的对应账单的利息
      const interest = [...state.interest];
      const rateItem = interest.find(item => item.billId === resRate.billId);
      // 如果账单id已经存在，更新利息，不存在，就把请求结果放到利息数组中
      if (rateItem) {
        rateItem.value = resRate.value;
      } else {
        interest.push(resRate);
      }
      return {
        ...state,
        interest,
      };
    },
    setInterest(state, { payload: resRate }) {
      // 需要设置对应项目的对应账单的利息
      const loanList = { ...state.loanList };
      loanList.projectList = [...loanList.projectList];
      let rateItem = null;
      for (let i = 0; i < loanList.projectList.length; i++) {
        const { billList = [] } = loanList.projectList[i];
        rateItem = billList.find(item => item.billId === resRate.billId);
        if (rateItem) {
          break;
        }
      }
      // 如果账单id已经存在，更新利息，不存在，就把请求结果放到利息数组中
      rateItem.rateValue = resRate.rateValue;
      return {
        ...state,
        loanList,
      };
    },
    setLoanplaninfo(state, { payload: loanplaninfo }) {
      return {
        ...state,
        loanplaninfo: {
          ...state.loanplaninfo,
          ...loanplaninfo,
        },
      };
    },
    setLoanInvoiceInfo(state, { payload: loanInvoiceInfo }) {
      return {
        ...state,
        loanInvoiceInfo: {
          ...state.loanInvoiceInfo,
          ...loanInvoiceInfo,
        },
      };
    },
  },
  effects: {
    // 商户项目账单列表
    *getLoanList({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.project.list', {
          ...payload,
        });
        yield put({ type: 'setLoanList', payload: response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setLoanList', payload: {} });
      }
    },
    // 提前收款确认信息
    *getLoanApply({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.applyinfo.get', {
          ...payload,
        });
        yield put({ type: 'setLoanApply', payload: response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setLoanApply', payload: false });
      }
    },
    // 提前收款支用确认
    *getLoanConfirm({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.confirm', {
          ...payload,
        });
        yield put({ type: 'setLoanConfirm', payload: response });
      } catch (error) {
        // message.error(error.msg);
        yield put({ type: 'setLoanConfirm', payload: { status: error.msg } });
      }
    },
    // 获取短信校验码
    *getVerifyCode({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.confirm.verifycode.send', {
          ...payload,
        });
      } catch (error) {
        message.error(error.msg);
      }
    },
    // 验证短信校验码
    *checkVerifyCode({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.confirm.verifycode', {
          ...payload,
        });
        yield put({ type: 'setCodeStatus', payload: true });
      } catch (error) {
        yield put({ type: 'setCodeStatus', payload: error.msg });
      }
    },
    // 利息获取
    *getInterest({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.interest.get', {
          ...payload,
        });
        yield put({
          type: 'setInterest',
          payload: { billId: payload.billId, rateValue: response },
        });
      } catch (error) {
        message.error(error.msg);
        yield put({
          type: 'setInterest',
          payload: { billId: payload.billId, rateValue: 0 },
        });
      }
    },

    // 获取可提现金额
    *getLoanplaninfo({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.loanplaninfo.get', {
          ...payload,
        });

        yield put({ type: 'setLoanplaninfo', payload: response });
      } catch (error) {
        message.error(error.msg);

        yield put({ type: 'setLoanplaninfo', payload: {} });
      }
    },

    // 获取发票信息
    *getLoanInvoiceinfo({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'loan.invoiceinfo.get', {
          ...payload,
        });

        yield put({ type: 'setLoanInvoiceInfo', payload: response });
      } catch (error) {
        message.error(error.msg);

        yield put({ type: 'setLoanInvoiceInfo', payload: {} });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/proceed/collections.js